/** Average True Range (RMA / Wilder ATR)
 * @param {[{
 *   date: Number,
 *   open: Number,
 *   high: Number,
 *   low: Number,
 *   close: Number,
 *   volume: Number
 * }]} data candle data
 *
 * @param {number} period ATR period
 * @return {[[Number, Number]]} ATR values
 */
export default function atrRMA(data, period) {
      if (!data || data.length === 0 || period <= 0) return [];
    
      const atrOutput = [];
      const trueRange = [];
    
      // 1. Calculate True Range matching built-in library logic
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          trueRange.push(data[i].high - data[i].low);
        } else {
          trueRange.push(
            Math.max(
              data[i].high - data[i].low,
              Math.abs(data[i].high - data[i - 1].close),
              Math.abs(data[i].low - data[i - 1].close)
            )
          );
        }
      }
    
      let prevATR = 0;
    
      // 2. Perform Wilder's RMA smoothing matching built-in library indexes
      for (let i = period - 1; i < data.length; i++) {
        if (i === period - 1) {
          // First ATR value = SMA of the first `period` TR values (from index 0 to period - 1)
          let sum = 0;
          for (let j = 0; j < period; j++) {
            sum += trueRange[j];
          }
          prevATR = sum / period;
          atrOutput.push([data[i].date, prevATR]);
        } else {
          // Wilder's RMA smoothing
          const currentATR = (trueRange[i] + (period - 1) * prevATR) / period;
          atrOutput.push([data[i].date, currentATR]);
          prevATR = currentATR;
        }
      }
    
      return atrOutput;
    }